if (!customElements.get("m-collection-list")) {
  class MCollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper", // slideContainer
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = this.dataset.items;
      this.total = this.dataset.total;
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = this.dataset.autoplaySpeed;
      this.paginationType = this.dataset.paginationType;
      this.expanded = this.dataset.expanded === "true";
      this.mobileDisableSlider = this.dataset.mobileDisableSlider === "true";

      this.initByScreenSize();
      document.addEventListener("matchMobile", () => {
        this.initByScreenSize();
      });
      document.addEventListener("unmatchMobile", () => {
        this.initByScreenSize();
      });
    }

    initByScreenSize() {
      if (!this.enableSlider) return;
      const { slideContainer, slideControls } = queryDomNodes(this.selectors, this);

      if (MinimogTheme.config.mqlMobile && this.mobileDisableSlider) {
        slideControls?.classList.add("m:hidden");
        slideContainer.classList.remove("swiper-container");
        if (this.swiper) this.swiper.destroy(false, true);
      } else {
        slideControls?.classList.remove("m:hidden");
        this.initSlider();
      }
    }

    initSlider() {
      const { slideContainer } = queryDomNodes(this.selectors, this);

      slideContainer?.classList.add("swiper-container");

      const modelNav = this.dataset.modelNav === "true";
      const modelButtons = this.dataset.modelButtons === "true";
      // o tema recria o carrossel em mudanças de tela; com setas, desmonta o anterior para o contador não se perder
      if (modelNav && this.slider && !this.slider.destroyed) this.slider.destroy(true, true);
      // celular: lista circular (antes do primeiro vem o último); computador: com começo e fim
      const modelLoop = modelNav && MinimogTheme.config.mqlMobile;
      const paginationIcon = `<svg width="65px" height="65px" viewBox="0 0 72 72" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><circle class="time" stroke-width="5" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle></svg>`;
      this.slider = new MinimogLibs.Swiper(slideContainer, {
        slidesPerView: modelNav ? "auto" : 2,
        loop: modelNav ? modelLoop : true,
        loopedSlides: modelLoop ? parseInt(this.total) : null,
        slidesPerGroup: 1,
        // botões de modelo: arrastar livre com embalo, encaixando no botão mais próximo
        freeMode: modelButtons,
        freeModeSticky: modelButtons,
        freeModeMomentumRatio: 1,
        showNavigation: true,
        showPagination: true,
        parallax: true,
        autoplay: this.autoplay
          ? {
              delay: parseInt(this.autoplaySpeed) * 1000,
            }
          : false,
        pagination:
          this.paginationType == "fraction"
            ? {
                el: this.querySelector(".swiper-pagination"),
                clickable: true,
                type: "fraction",
              }
            : {
                el: this.querySelector(".swiper-pagination"),
                clickable: true,
                bulletClass: "m-dot",
                bulletActiveClass: "m-dot--active",
                renderBullet: function (index, className) {
                  return '<span class="' + className + '">' + paginationIcon + "</span>";
                },
              },
        autoHeight: true,
        breakpoints: {
          480: {
            slidesPerView: modelNav ? "auto" : 3,
          },
          768: {
            slidesPerView: parseInt(this.items) >= 3 ? 3 : parseInt(this.items),
          },
          1280: {
            slidesPerView: this.expanded && this.total > this.items ? parseInt(this.items) + 1 : parseInt(this.items),
          },
        },
        on: {
          init() {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
          },
        },
      });

      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");

      if (this.slider && prevButton && nextButton) {
        prevButton && prevButton.addEventListener("click", () => this.slider.slidePrev());
        nextButton && nextButton.addEventListener("click", () => this.slider.slideNext());
      }

      this.swiper = slideContainer?.swiper;
      if (modelNav) this.initModelNav();
    }

    // Setas ‹ › e contador "1 de N modelos" (botões de modelo)
    initModelNav() {
      const nav = this.querySelector("[data-model-nav]");
      const slider = this.slider;
      if (!nav || !slider) return;
      const prev = nav.querySelector("[data-model-prev]");
      const next = nav.querySelector("[data-model-next]");
      const current = nav.querySelector("[data-model-current]");
      const total = parseInt(this.total);
      const update = () => {
        const perView = slider.params.slidesPerView;
        if (slider.params.loop) {
          // lista circular: mostra o modelo atual e as setas nunca apagam
          current.textContent = slider.realIndex + 1;
          prev.disabled = false;
          next.disabled = false;
          return;
        }
        if (perView === "auto") {
          // celular: um modelo por vez ("1 de 27")
          current.textContent = slider.isEnd ? total : Math.min(slider.activeIndex + 1, total);
        } else {
          // computador: faixa de modelos visíveis ("1–4 de 27")
          const count = Math.min(Math.round(perView), total);
          const first = slider.isEnd ? total - count + 1 : Math.min(slider.activeIndex + 1, total - count + 1);
          current.textContent = count > 1 ? `${first}–${first + count - 1}` : first;
        }
        prev.disabled = slider.isBeginning;
        next.disabled = slider.isEnd;
      };
      prev.onclick = () => slider.slidePrev();
      next.onclick = () => slider.slideNext();
      ["slideChange", "reachBeginning", "reachEnd", "fromEdge", "resize", "breakpoint", "transitionEnd", "touchEnd"].forEach((e) => slider.on(e, update));
      update();
    }
  }

  customElements.define("m-collection-list", MCollectionList);
}
